import "./vendors/css/normalize.css";
import "bootstrap/dist/css/bootstrap.css";
import "./vendors/css/animate.css";
import "./vendors/css/ionicons.min.css";
import "./css/site.css";
import "./css/header.css";
import "./css/footer.css";
import "./css/videolanding.css";
import "./css/parallaxbackground.css";
import "./css/executiveTeam.css";
import "./css/forms.css";
import "./css/jobs.css";
import "./css/clients.css";
import "./css/services.css";
import "./css/approach.css";

import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import { BrowserRouter, Route } from "react-router-dom";
import reduxThunk from "redux-thunk";
import reducers from "./reducers";
import url from "./utils/routeUrls";
import App from "./components/App";
import Home from "./components/home/Home";

//Font
import WebFont from "webfontloader";

// Development only axios helpers!
import axios from "axios";
window.axios = axios;

//loading font!
WebFont.load({
  google: {
    families: ["Montserrat:300,400,700", "sans-serif"]
  }
});

const store = createStore(
  reducers,
  {
    auth: {
      authenticated: localStorage.getItem("token"),
      userId: localStorage.getItem("userId"),
      roles: JSON.parse(localStorage.getItem("roles")),
      preferences: JSON.parse(localStorage.getItem("preferences"))
    } // Loads JWT and userId from local storage when app starts, so login state is preserved
  },
  applyMiddleware(reduxThunk)
);

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <App>
        <Route path={url.HOME} exact component={Home} />
      </App>
    </BrowserRouter>
  </Provider>,
  document.querySelector("#root")
);
